// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__u_7JS","text":"SelectPayment_text__3LqHG","title":"SelectPayment_title__MaoWc","btn":"SelectPayment_btn__16elb"};